import Layout from '@/views/investment_plan/Layout.vue';

export default {
    path: '/investment_plan',
    component: Layout,
    children: [
        { path: 'summary', component: () => import('@/views/investment_plan/Summary.vue') },
        { path: 'details', component: () => import('@/views/investment_plan/Details.vue') },
        { path: 'add-summary', component: () => import('@/views/investment_plan/AddSummary.vue') },
    ]
};
